// External libs
import { createSelector } from 'reselect';
// Interfaces
import { State } from '../interfaces/state';
import { SupportSuggestion } from '../../../interfaces';

const selectSlice: (state: any) => State = (state: any) =>
  state.justCookedOrderIssueDialog;

const selectOpen = createSelector<any, State, boolean>(
  selectSlice,
  (reducer) => reducer.open,
);

const selectOrderId = createSelector<any, State, number>(
  selectSlice,
  (reducer) => reducer.orderId,
);

const selectDescription = createSelector<any, State, string>(
  selectSlice,
  (reducer) => reducer.description,
);

const selectSupportSuggestions = createSelector<
  any,
  State,
  SupportSuggestion[]
>(selectSlice, (reducer) => reducer.supportSuggestions);

const selectors = {
  selectOpen,
  selectOrderId,
  selectDescription,
  selectSupportSuggestions,
};

export default selectors;
